/**
 * 业务系统权限源数据 —— 本模块唯一需要手工维护的文件
 *
 * 来源：业务系统 client/src/router/index.js 的 constantRoutes
 * 用途：SSO 角色管理模块的「业务系统权限」勾选来源
 *
 * 结构说明：
 *   模块节点  { path, title, children:[...] }  授予即拥有该模块下全部页面
 *   紧随其后  该模块每个子页面再扁平铺一份 { path, title }
 *   独立页面  { path, title }                 不属于任何模块的页面
 *
 * 业务系统增删页面时，在这里同步增删改即可，其他文件无需改动。
 *
 * 共 113 条
 */

export const businessPermissionTree = [
  {
    path: '/dashboard',
    title: '首页'
  },
  {
    path: '/role',
    title: '角色模块',
    children: [
      { path: '/role/roleSingleMail', title: '玩家邮件' },
      { path: '/role/roleInfo', title: '封禁管理' },
      { path: '/role/roleMinuteInfo', title: '玩家信息' },
      { path: '/role/roleFlowData', title: '玩家流水数据' },
      { path: '/role/gmtRoleGift', title: '后台礼包发放' },
      { path: '/role/batchRoleDailyChargeGift', title: '批量日充值礼包发放' },
      { path: '/role/orderQuery', title: '订单查询' },
      { path: '/role/innerRole', title: '内部玩家查询' },
      { path: '/role/thirdRechargeOrder', title: '第三方充值' },
      { path: '/role/chatQuery', title: '聊天查询' },
      { path: '/role/roleSvip', title: '角色专属svip' },
      { path: '/role/gameOrderQuery', title: '通用支付订单查询' },
      { path: '/role/roleAnswerAct', title: '角色答题绑定' },
      { path: '/role/appLogin3DaysAct', title: 'app引流活动' },
      { path: '/role/mailQuery', title: '邮件查询' },
      { path: '/role/giftKeyQuery', title: '礼包码查询' },
      { path: '/role/familyManage', title: '联盟管理' },
      { path: '/role/playerProblemFeedback', title: '玩家问题反馈' },
      { path: '/role/roleVoucherShop', title: '代币商店' },
      { path: '/role/itemMonitor', title: '物品监控' }
    ]
  },
  {
    path: '/role/roleSingleMail',
    title: '玩家邮件'
  },
  {
    path: '/role/roleInfo',
    title: '封禁管理'
  },
  {
    path: '/role/roleMinuteInfo',
    title: '玩家信息'
  },
  {
    path: '/role/roleFlowData',
    title: '玩家流水数据'
  },
  {
    path: '/role/gmtRoleGift',
    title: '后台礼包发放'
  },
  {
    path: '/role/batchRoleDailyChargeGift',
    title: '批量日充值礼包发放'
  },
  {
    path: '/role/orderQuery',
    title: '订单查询'
  },
  {
    path: '/role/innerRole',
    title: '内部玩家查询'
  },
  {
    path: '/role/thirdRechargeOrder',
    title: '第三方充值'
  },
  {
    path: '/role/chatQuery',
    title: '聊天查询'
  },
  {
    path: '/role/roleSvip',
    title: '角色专属svip'
  },
  {
    path: '/role/gameOrderQuery',
    title: '通用支付订单查询'
  },
  {
    path: '/role/roleAnswerAct',
    title: '角色答题绑定'
  },
  {
    path: '/role/appLogin3DaysAct',
    title: 'app引流活动'
  },
  {
    path: '/role/mailQuery',
    title: '邮件查询'
  },
  {
    path: '/role/giftKeyQuery',
    title: '礼包码查询'
  },
  {
    path: '/role/familyManage',
    title: '联盟管理'
  },
  {
    path: '/role/playerProblemFeedback',
    title: '玩家问题反馈'
  },
  {
    path: '/role/roleVoucherShop',
    title: '代币商店'
  },
  {
    path: '/role/itemMonitor',
    title: '物品监控'
  },
  {
    path: '/globalServer',
    title: '全服模块',
    children: [
      { path: '/globalServer/giftKey', title: '礼包码' },
      { path: '/globalServer/deviceWhite', title: '设备白名单' },
      { path: '/globalServer/selectAllProp', title: '所有道具信息' },
      { path: '/globalServer/gameServerList', title: '游戏服列表' },
      { path: '/globalServer/vsServerList', title: '虚拟服列表' },
      { path: '/globalServer/warZoneList', title: '战区列表' },
      { path: '/globalServer/crossServerList', title: '跨服节点' },
      { path: '/globalServer/globalServerMail', title: '全服邮件' },
      { path: '/globalServer/schedule', title: '任务调度' },
      { path: '/globalServer/rollNotice', title: '滚动公告管理' },
      { path: '/globalServer/customerServiceInfo', title: '客服信息设置' },
      { path: '/globalServer/channelInfo', title: '渠道信息设置' },
      { path: '/globalServer/loginNotice', title: '登录公告设置' },
      { path: '/globalServer/badWord', title: '屏蔽词' },
      { path: '/globalServer/timingOpenServer', title: '自动开服配置' },
      { path: '/globalServer/commentReward', title: '评论有奖' },
      { path: '/globalServer/questionnaire', title: '调查问卷' },
      { path: '/globalServer/miniGame', title: '迷你游戏' },
      { path: '/globalServer/clientGroupFilter', title: '客户端分组' },
      { path: '/globalServer/globalGmConfig', title: '服务器配置' },
      { path: '/globalServer/thirdAttractTrafficInfo', title: '第三方充值引流弹窗' },
      { path: '/globalServer/h5TransferConfig', title: 'h5转端配置' },
      { path: '/globalServer/rechargeGoodsConfig', title: '母包商品配置' },
      { path: '/globalServer/serverRename', title: '服务器冠名' },
      { path: '/globalServer/packageMap', title: '包体映射配置' },
      { path: '/globalServer/crossLadderMatch', title: '跨服天梯赛' },
      { path: '/globalServer/mergeZone', title: 'slg战区合并' },
      { path: '/globalServer/serverConfigUrl', title: '服务器入口地址配置' },
      { path: '/globalServer/baseChannel', title: '母包管理' },
      { path: '/globalServer/backendAct', title: '后台活动' },
      { path: '/globalServer/downFollowGift', title: '下载/关注有礼' },
      { path: '/globalServer/recommendTimezone', title: '时区推荐服' },
      { path: '/globalServer/tianyouShare', title: '天游截屏分享' },
      { path: '/globalServer/clientResMode', title: '客户端资源切换' }
    ]
  },
  {
    path: '/globalServer/giftKey',
    title: '礼包码'
  },
  {
    path: '/globalServer/deviceWhite',
    title: '设备白名单'
  },
  {
    path: '/globalServer/selectAllProp',
    title: '所有道具信息'
  },
  {
    path: '/globalServer/gameServerList',
    title: '游戏服列表'
  },
  {
    path: '/globalServer/vsServerList',
    title: '虚拟服列表'
  },
  {
    path: '/globalServer/warZoneList',
    title: '战区列表'
  },
  {
    path: '/globalServer/crossServerList',
    title: '跨服节点'
  },
  {
    path: '/globalServer/globalServerMail',
    title: '全服邮件'
  },
  {
    path: '/globalServer/schedule',
    title: '任务调度'
  },
  {
    path: '/globalServer/rollNotice',
    title: '滚动公告管理'
  },
  {
    path: '/globalServer/customerServiceInfo',
    title: '客服信息设置'
  },
  {
    path: '/globalServer/channelInfo',
    title: '渠道信息设置'
  },
  {
    path: '/globalServer/loginNotice',
    title: '登录公告设置'
  },
  {
    path: '/globalServer/badWord',
    title: '屏蔽词'
  },
  {
    path: '/globalServer/timingOpenServer',
    title: '自动开服配置'
  },
  {
    path: '/globalServer/commentReward',
    title: '评论有奖'
  },
  {
    path: '/globalServer/questionnaire',
    title: '调查问卷'
  },
  {
    path: '/globalServer/miniGame',
    title: '迷你游戏'
  },
  {
    path: '/globalServer/clientGroupFilter',
    title: '客户端分组'
  },
  {
    path: '/globalServer/globalGmConfig',
    title: '服务器配置'
  },
  {
    path: '/globalServer/thirdAttractTrafficInfo',
    title: '第三方充值引流弹窗'
  },
  {
    path: '/globalServer/h5TransferConfig',
    title: 'h5转端配置'
  },
  {
    path: '/globalServer/rechargeGoodsConfig',
    title: '母包商品配置'
  },
  {
    path: '/globalServer/serverRename',
    title: '服务器冠名'
  },
  {
    path: '/globalServer/packageMap',
    title: '包体映射配置'
  },
  {
    path: '/globalServer/crossLadderMatch',
    title: '跨服天梯赛'
  },
  {
    path: '/globalServer/mergeZone',
    title: 'slg战区合并'
  },
  {
    path: '/globalServer/serverConfigUrl',
    title: '服务器入口地址配置'
  },
  {
    path: '/globalServer/baseChannel',
    title: '母包管理'
  },
  {
    path: '/globalServer/backendAct',
    title: '后台活动'
  },
  {
    path: '/globalServer/downFollowGift',
    title: '下载/关注有礼'
  },
  {
    path: '/globalServer/recommendTimezone',
    title: '时区推荐服'
  },
  {
    path: '/globalServer/tianyouShare',
    title: '天游截屏分享'
  },
  {
    path: '/globalServer/clientResMode',
    title: '客户端资源切换'
  },
  {
    path: '/logs',
    title: '日志模块',
    children: [
      { path: '/logs/gmLogs', title: '游戏日志' },
      { path: '/logs/matchLogs', title: '多日志查询' }
    ]
  },
  {
    path: '/logs/gmLogs',
    title: '游戏日志'
  },
  {
    path: '/logs/matchLogs',
    title: '多日志查询'
  },
  {
    path: '/admin',
    title: '管理员模块',
    children: [
      { path: '/admin/user', title: '账号管理' },
      { path: '/admin/operationLog', title: '操作记录' },
      { path: '/admin/verifyGlobalServerMail', title: '审核全服邮件' },
      { path: '/admin/verifyRoleMail', title: '审核玩家邮件' },
      { path: '/admin/verifyExpensiveRoleMail', title: '高价值玩家邮件审核' },
      { path: '/admin/activityConfig', title: '功能解锁和关闭' },
      { path: '/admin/serverDebug', title: '服务端代码调试' },
      { path: '/admin/bigGroup', title: '大区权限维护' },
      { path: '/admin/verifyThirdRechargeOrder', title: '审核第三方充值' }
    ]
  },
  {
    path: '/admin/user',
    title: '账号管理'
  },
  {
    path: '/admin/operationLog',
    title: '操作记录'
  },
  {
    path: '/admin/verifyGlobalServerMail',
    title: '审核全服邮件'
  },
  {
    path: '/admin/verifyRoleMail',
    title: '审核玩家邮件'
  },
  {
    path: '/admin/verifyExpensiveRoleMail',
    title: '高价值玩家邮件审核'
  },
  {
    path: '/admin/activityConfig',
    title: '功能解锁和关闭'
  },
  {
    path: '/admin/serverDebug',
    title: '服务端代码调试'
  },
  {
    path: '/admin/bigGroup',
    title: '大区权限维护'
  },
  {
    path: '/admin/verifyThirdRechargeOrder',
    title: '审核第三方充值'
  },
  {
    path: '/testmodule',
    title: '测试模块',
    children: [
      { path: '/testmodule/test', title: '测试页面' },
      { path: '/testmodule/prepareShutdownServer', title: '关服预处理' }
    ]
  },
  {
    path: '/testmodule/test',
    title: '测试页面'
  },
  {
    path: '/testmodule/prepareShutdownServer',
    title: '关服预处理'
  },
  {
    path: '/reportData',
    title: '报表数据查询',
    children: [
      { path: '/reportData/baseData', title: '运营基础数据' },
      { path: '/reportData/baseDataSummary', title: '基础数据汇总' },
      { path: '/reportData/serverBaseData', title: '分服基础数据' },
      { path: '/reportData/registerHours', title: '注册时表' },
      { path: '/reportData/payHours', title: '付费时表' },
      { path: '/reportData/onlineHours', title: '在线时表' },
      { path: '/reportData/payContribute', title: '用户付费贡献' },
      { path: '/reportData/payContinue', title: '用户持续付费' },
      { path: '/reportData/rollServerData', title: '滚服数据统计' },
      { path: '/reportData/vipRetention', title: 'VIP留存统计' },
      { path: '/reportData/stageDistribution', title: '关卡分布' },
      { path: '/reportData/roleGuide', title: '新手步骤流失' },
      { path: '/reportData/firstPay', title: '首次付费分析' },
      { path: '/reportData/consumeItem', title: '道具获得消耗分布' },
      { path: '/reportData/roleList', title: '角色列表查询' },
      { path: '/reportData/roleLTV', title: '角色LTV' },
      { path: '/reportData/ursLTV', title: '注册LTV' },
      { path: '/reportData/retentionAnalysis', title: '留存分析' },
      { path: '/reportData/payGoods', title: '礼包购买' },
      { path: '/reportData/rechargeRank', title: '累充排行' },
      { path: '/reportData/payRoleProgress', title: '付费玩家进度' },
      { path: '/reportData/payRoleStructure', title: '付费玩家结构' },
      { path: '/reportData/mainStageProgress', title: '主线关卡进度' },
      { path: '/reportData/towerLayerProgress', title: '试炼塔进度' },
      { path: '/reportData/roleHeroAndEquipProgress', title: '角色养成进度' },
      { path: '/reportData/gamePlayParticipation', title: '玩法参与率' },
      { path: '/reportData/classMainStageProgress', title: '分层主线关卡进度' },
      { path: '/reportData/classPayRoleProgress', title: '分层付费玩家进度' },
      { path: '/reportData/newPayRoleProgress', title: '付费玩家进度new' },
      { path: '/reportData/storeBuyQuery', title: '商店购买查询' },
      { path: '/reportData/playMethodAnalysis', title: '玩法分析' },
      { path: '/reportData/lostPlayers', title: '流失玩家查询' },
      { path: '/reportData/itemAnalysis', title: '物品分析' },
      { path: '/reportData/firstPayGoodsAnalysis', title: '首充礼包分析' },
      { path: '/reportData/firstMainStageAnalysis', title: '首充时间分析' },
      { path: '/reportData/monthlyRechargeSummary', title: '月充值汇总' },
      { path: '/reportData/payGoodsSummary', title: '礼包购买汇总' },
      { path: '/reportData/payRoleDay1Info', title: '付费用户首日数据' },
      { path: '/reportData/doneRoleGuide', title: '完成新手步骤' }
    ]
  },
  {
    path: '/reportData/baseData',
    title: '运营基础数据'
  },
  {
    path: '/reportData/baseDataSummary',
    title: '基础数据汇总'
  },
  {
    path: '/reportData/serverBaseData',
    title: '分服基础数据'
  },
  {
    path: '/reportData/registerHours',
    title: '注册时表'
  },
  {
    path: '/reportData/payHours',
    title: '付费时表'
  },
  {
    path: '/reportData/onlineHours',
    title: '在线时表'
  },
  {
    path: '/reportData/payContribute',
    title: '用户付费贡献'
  },
  {
    path: '/reportData/payContinue',
    title: '用户持续付费'
  },
  {
    path: '/reportData/rollServerData',
    title: '滚服数据统计'
  },
  {
    path: '/reportData/vipRetention',
    title: 'VIP留存统计'
  },
  {
    path: '/reportData/stageDistribution',
    title: '关卡分布'
  },
  {
    path: '/reportData/roleGuide',
    title: '新手步骤流失'
  },
  {
    path: '/reportData/firstPay',
    title: '首次付费分析'
  },
  {
    path: '/reportData/consumeItem',
    title: '道具获得消耗分布'
  },
  {
    path: '/reportData/roleList',
    title: '角色列表查询'
  },
  {
    path: '/reportData/roleLTV',
    title: '角色LTV'
  },
  {
    path: '/reportData/ursLTV',
    title: '注册LTV'
  },
  {
    path: '/reportData/retentionAnalysis',
    title: '留存分析'
  },
  {
    path: '/reportData/payGoods',
    title: '礼包购买'
  },
  {
    path: '/reportData/rechargeRank',
    title: '累充排行'
  },
  {
    path: '/reportData/payRoleProgress',
    title: '付费玩家进度'
  },
  {
    path: '/reportData/payRoleStructure',
    title: '付费玩家结构'
  },
  {
    path: '/reportData/mainStageProgress',
    title: '主线关卡进度'
  },
  {
    path: '/reportData/towerLayerProgress',
    title: '试炼塔进度'
  },
  {
    path: '/reportData/roleHeroAndEquipProgress',
    title: '角色养成进度'
  },
  {
    path: '/reportData/gamePlayParticipation',
    title: '玩法参与率'
  },
  {
    path: '/reportData/classMainStageProgress',
    title: '分层主线关卡进度'
  },
  {
    path: '/reportData/classPayRoleProgress',
    title: '分层付费玩家进度'
  },
  {
    path: '/reportData/newPayRoleProgress',
    title: '付费玩家进度new'
  },
  {
    path: '/reportData/storeBuyQuery',
    title: '商店购买查询'
  },
  {
    path: '/reportData/playMethodAnalysis',
    title: '玩法分析'
  },
  {
    path: '/reportData/lostPlayers',
    title: '流失玩家查询'
  },
  {
    path: '/reportData/itemAnalysis',
    title: '物品分析'
  },
  {
    path: '/reportData/firstPayGoodsAnalysis',
    title: '首充礼包分析'
  },
  {
    path: '/reportData/firstMainStageAnalysis',
    title: '首充时间分析'
  },
  {
    path: '/reportData/monthlyRechargeSummary',
    title: '月充值汇总'
  },
  {
    path: '/reportData/payGoodsSummary',
    title: '礼包购买汇总'
  },
  {
    path: '/reportData/payRoleDay1Info',
    title: '付费用户首日数据'
  },
  {
    path: '/reportData/doneRoleGuide',
    title: '完成新手步骤'
  }
];

export default businessPermissionTree;
